import { useColorModeValue } from "@chakra-ui/react";

/**
 * Hook returning color-mode-aware tokens for ElasticStatusCard sections.
 * Provides consistent box, label, value, and title colors across sub-components.
 * @returns {object} Color tokens: boxBg, label, value, title.
 */
export function useSectionColors() {
    const boxBg = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
    const label = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    const value = useColorModeValue("secondaryGray.900", "white");
    const title = useColorModeValue("secondaryGray.900", "white");
    return { boxBg, label, value, title };
}
